const routes = {
  createDeliveryTimeSlot: 'delivery-time-slot',
  getDeliveryTimeSlots: 'delivery-time-slot',
  getDeliveryTimeSlotById: 'delivery-time-slot/',
  updateDeliveryTimeSlot: 'delivery-time-slot/',
  deleteDeliveryTimeSlot: 'delivery-time-slot/',
};

export default routes